import { render, staticRenderFns } from "./relatorioEnriquecimento.vue?vue&type=template&id=074755e8"
import script from "./relatorioEnriquecimento.vue?vue&type=script&lang=js"
export * from "./relatorioEnriquecimento.vue?vue&type=script&lang=js"
import style0 from "./relatorioEnriquecimento.vue?vue&type=style&index=0&id=074755e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports